module.exports = __webpack_public_path__ + "static/img/wire_landing_10_en.fb4084d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wire_landing_10_en.jpg
// module id = 9qG2
// module chunks = 0